// removed by extract-text-webpack-plugin
module.exports = {"section":"src-pages----services-module---section---1Mw5d","content":"src-pages----services-module---content---d2015","smallCaps":"src-pages----services-module---smallCaps---2wacy","pointers":"src-pages----services-module---pointers---2PnXk","icon":"src-pages----services-module---icon---2IUuY"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/services.module.scss
// module id = 569
// module chunks = 269829036549620